import { SettingsTitle } from "../../SettingsTitle"
import { useTranslation } from "react-i18next"
import PaypalAccountCard from "./PaypalAccountCard"
import { Flex } from "antd"

const PaypalAccount = () => {
  const { t } = useTranslation()

  return (
    <Flex vertical>
      <SettingsTitle title={t("pro.settings.paypal.title")} />
      <PaypalAccountCard source="settings" />
    </Flex>
  )
}

export default PaypalAccount
